"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiTabs = getMuiTabs;
/* eslint-disable sort-keys */

function getMuiTabs(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required'
    },
    styleOverrides: {
      root: {
        '._search_tabcount': {
          backgroundColor: palette.neutral[100],
          borderRadius: 5,
          color: palette.neutral[600],
          height: 16,
          marginLeft: '8px',
          top: 12,
          padding: '0px 8px 0px 8px'
        },
        '._search_tabicon': {
          borderRadius: 5,
          bottom: 8,
          marginLeft: '8px',
          padding: '0px 8px 0px 8px',
          top: 2
        },
        '& .MuiSvgIcon-root': {
          height: '18px',
          width: '18px'
        },
        '.MuiTab-root': {
          color: palette.neutral[600],
          fontSize: 14,
          fontWeight: 600,
          padding: '12px 32px 12px 32px',
          textTransform: 'none',
          height: '36px',
          lineHeight: '22px',
          minHeight: '36px',
          '&.Mui-disabled': {
            color: palette.neutral[300],
            '._search_tabcount': {
              color: palette.neutral[300],
              backgroundColor: palette.neutral[50]
            },
            '._search_tabicon': {
              borderRadius: 5,
              bottom: 8,
              marginLeft: '8px',
              padding: '0px 8px 0px 8px',
              top: 2
            }
          },
          '&.Mui-selected': {
            borderBottom: "2px solid ".concat(palette.primary[700]),
            color: palette.primary[700],
            '._search_tabcount': {
              backgroundColor: palette.primary[50],
              borderRadius: 5,
              color: palette.primary[700],
              height: 16,
              marginLeft: '8px',
              top: 12,
              padding: '0px 8px 0px 8px'
            },
            '._search_tabicon': {
              borderRadius: 5,
              bottom: 8,
              marginLeft: '8px',
              padding: '0px 8px 0px 8px',
              top: 2
            },
            '&.textColorInherit': {
              '&.MuiTab-textColorInherit': {
                color: palette.neutral[600]
              }
            }
          },
          '&:not(&.Mui-selected)': {
            '._search_tabicon': {
              borderRadius: 5,
              bottom: 8,
              marginLeft: '8px',
              padding: '0px 8px 0px 8px',
              top: 2
            }
          }
        },
        minHeight: '36px'
      }
    }
  };
}